import styled from '@emotion/styled';
import { withTheme } from '@emotion/react';
import React from 'react';
import { TestId } from '@components/test-ids';
import { ThemeProps } from '@theme/base';
import { RequestQuoteFormContainer } from './contact-forms';

/* ***************** *
 *       Types       *
 * ***************** */

export interface ContactFormGroupProps {
  title: string;
  description: string;
  testId?: string;
}

/* ***************** *
 *       Styles      *
 * ***************** */
const Container = styled.div({});

const SectionTitle = styled.h4(({ theme }: ThemeProps) => ({
  ...(theme.custom.typography.h4 as any)
}));

/* ******************************* *
 *    ContactFormGroupComponent    *
 * ******************************* */

export const ContactFormGroupComponent = (props: ContactFormGroupProps) => {
  const { testId, title, description } = props;

  return (
    <Container data-testid={testId || TestId.contactForms.formGroup}>
      <SectionTitle>{title}</SectionTitle>
      <p>{description}</p>
      <RequestQuoteFormContainer />
    </Container>
  );
};

export const ContactFormGroup = withTheme(ContactFormGroupComponent);
